module.exports = __webpack_public_path__ + "static/ogp-contact-7af9a093842715cfc76b600f3f735dd1.png";